export const styles = {
  modalStyles: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000,
    '& h2': {
      fontSize: 24,
      fontWeight: 700,
      margin: 0,
    },
  },
  contentStyles: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    padding: '24px 32px',
    borderRadius: '8px',
    maxWidth: '550px',
    maxHeight: '220px',
    width: '100%',
    textAlign: 'left',
    gap: 24,
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 10,
    gap: 32,
  },
  cancelButton: {
    backgroundColor: '#FFF',
    color: '#000',
    borderRadius: 12,
    border: '1px solid',
    height: 40,
    maxWidth: 230,
    width: '100%',
  },
  sendEmailButton: {
    backgroundColor: '#004360',
    color: '#FFF',
    borderRadius: 12,
    border: '1px solid #004360',
    height: 40,
    maxWidth: 230,
    width: '100%',
  },
  sendEmailButtonDisabled: {
    backgroundColor: '#E4E4EA',
    color: '#C2C5DD',
    cursor: 'not-allowed',
    border: '1px solid #E4E4EA',
    borderRadius: 12,
    height: 40,
    maxWidth: 230,
    width: '100%',
  },
}
